import axios from './financeiroApi';

const PATH = '/api/v1/backend/empresas/onboarding';

const empresaOnboardingApi = {
  findStatus: async () => {
    return axios.get(`${PATH}/buscar`);
  },
  atualizar: async (empresaUuid, etapa, empresaOnboarding) => {
    return axios.put(`${PATH}?empresaId=${empresaUuid}&etapa=${etapa}`, empresaOnboarding);
  },
  findConta: async (empresaId) => {
    return axios.get(`${PATH}/conta/${empresaId}`);
  },
  findStatusTributacao: async () => {
    return axios.get(`${PATH}/situacao-fiscal`);
  },
};

export default empresaOnboardingApi;
